import useSWR from "swr";
import useSWRMutation from "swr/mutation";
import {
  MeasurementSystem,
  CreateMeasurementSystem,
  UpdateMeasurementSystem,
} from "@/types/measurementSystem";
import {
  SWRApiError,
  swrConfigOptions,
  UpdaterParams,
  useDeleter,
  useFetcher,
  useMutater,
  useUpdater,
} from "./swr";

type MeasurementSystemTable = MeasurementSystem & {
  is_in_use?: boolean;
};

export const useMeasurementSystems = () => {
  const fetcher = useFetcher();

  const { data = [], ...rest } = useSWR<MeasurementSystemTable[], SWRApiError>(
    { url: "/measurement_systems" },
    fetcher,
    swrConfigOptions,
  );

  return { data, ...rest };
};

export const useMeasurementSystem = (id?: number) => {
  const fetcher = useFetcher();

  const { data, ...rest } = useSWR<MeasurementSystem, SWRApiError>(
    id ? { url: `/measurement_systems/${id}` } : null,
    fetcher,
    swrConfigOptions,
  );

  return { data: data ?? null, ...rest };
};

export const useDeleteMeasurementSystem = () => {
  const deleter = useDeleter();

  return useSWRMutation<void, SWRApiError, string, { id: string }>("/measurement_systems", deleter);
};

export const useCreateMeasurementSystem = () => {
  const mutater = useMutater();

  return useSWRMutation<any, SWRApiError, string, CreateMeasurementSystem>(
    "/measurement_systems",
    mutater,
  );
};

export const useUpdateMeasurementSystem = () => {
  const updater = useUpdater();

  return useSWRMutation<void, SWRApiError, UpdaterParams, UpdateMeasurementSystem & { id: string }>(
    { url: "/measurement_systems" },
    updater,
  );
};
